// The legal pages' paths (LegalPage.js), kept apart so any page can link to them without an import cycle
export const TERMS_PATH = '/terms';
export const PRIVACY_PATH = '/privacy';
export const COOKIES_PATH = '/cookies';
// The FAQ page (FaqPage.js)
export const FAQ_PATH = '/faq';
